export class LoaderService {

  static loading: boolean = true;

  constructor() { }

  static startLoading() {
    LoaderService.loading = true;
  }

  static stopLoading() {
    LoaderService.loading = false;
  }
}
